import { Link } from "react-router-dom";
import { Brand } from "@/components/Brand";
import { useAuth } from "@/context/AuthContext";

export function SiteFooter() {
    const { settings } = useAuth();
    const contact = settings?.contact_email;
    return (
        <footer className="border-t border-line bg-cream">
            <div className="mx-auto flex max-w-6xl flex-col gap-6 px-6 py-12 sm:flex-row sm:items-center sm:justify-between">
                <div>
                    <Brand size="text-[18px]" />
                    <p className="mt-2 max-w-sm text-[14px] leading-[1.6] text-subtle">
                        Cuidado de la piel con cabeza. Analizamos tu piel, revisamos tu neceser y te
                        decimos qué comprar de verdad.
                    </p>
                </div>
                <div className="flex flex-col gap-2 text-[14px] text-subtle sm:items-end">
                    <Link to="/privacidad" className="hover:text-ink" data-testid="footer-privacy-link">
                        Privacidad y datos
                    </Link>
                    <Link to="/legal" className="hover:text-ink" data-testid="footer-legal-link">
                        Aviso legal y condiciones
                    </Link>
                    <span>
                        Contacto:{" "}
                        {contact ? (
                            <a href={`mailto:${contact}`} className="hover:text-ink">
                                {contact}
                            </a>
                        ) : (
                            "aún no disponible"
                        )}
                    </span>
                    <span className="text-[13px]">© {new Date().getFullYear()} MYAVEREN</span>
                </div>
            </div>
        </footer>
    );
}
